module.exports = __webpack_public_path__ + "static/media/Christina Johnson Headshot.88b8e9c8.png";